import { render } from "./OrderTableHeader.vue?vue&type=template&id=22ad2304&scoped=true&ts=true"
import script from "./OrderTableHeader.vue?vue&type=script&lang=ts"
export * from "./OrderTableHeader.vue?vue&type=script&lang=ts"

import "./OrderTableHeader.vue?vue&type=style&index=0&id=22ad2304&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad2304"]])

export default __exports__